import React from 'react';

import { ButtonSwitch, ButtonSwitchGroup } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useListTypeContext } from '../ListTypeContext';

export function SwitchListTypeButton(): React.JSX.Element {
  const { listType, setListType } = useListTypeContext();
  const { t } = useTranslation();

  return (
    <ButtonSwitchGroup
      onChange={setListType}
      size="small"
      value={listType}
      variant="square"
    >
      <ButtonSwitch
        value="cards"
      >
        {t('list-details-page:titles.tabs.cards')}
      </ButtonSwitch>
      <ButtonSwitch
        disabled
        value="faces"
      >
        {t('list-details-page:titles.tabs.faces')}
      </ButtonSwitch>
    </ButtonSwitchGroup>
  );
}
